'use strict';

/**
 * Wrap substitutions
 */
module.exports = function wrap(substitutions) {
  var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '{{';
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '}}';
  //Process arrays
  if (Array.isArray(substitutions)) {
    return substitutions.map(function (subs) {
      return wrap(subs, left, right);
    });
  }

  //Initialize new wrapped object
  var wrapped = {};

  //Map substitutions and ensure string for value
  for (var key in substitutions) {
    //istanbul ignore else
    if (substitutions.hasOwnProperty(key)) {
      wrapped[left + key + right] = String(substitutions[key]);
    }
  }

  //Return wrapped substitutions
  return wrapped;
};